/* eslint-disable */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import client from '../../api/client';
import ModalLoad from '../../components/modal/ModalLoad';
import ModalPopupMessage from '../../components/modal/ModalPopupMessage';
import placeholderImg from '../../assets/images/placeholder.webp';
import './CardMyCart.css';
import './MarketPlace.css';

import dayjs from 'dayjs';
import dayTh from 'dayjs/locale/th';
import buddhistEra from 'dayjs/plugin/buddhistEra';

dayjs.extend(buddhistEra);
dayjs.locale(dayTh);

function MyCart(props) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const location = useLocation();
  let [searchParams, setSearchParams] = useSearchParams();
  const shopId = props.permitdata?.shop_id;

  const [remove_id, setRemove_id] = useState('');
  const [mycart_data, setMycart_data] = useState([]);
  const [mycart_summary, setMycart_summary] = useState([]);
  const [modal_load, setmodal_load] = useState({ enable: false, message: '' });
  const [modal_popup, setModal_popup] = useState({
    modaltype: '',
    headers: '',
    message: '',
    enable: false,
  });
  const [select_all, setSelect_all] = useState(false);

  function showDialogCallback_General(message) {
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
  }

  const submit_deletecart = (cart_id) => {
    const next = mycart_data.filter((item) => item.cart_id !== cart_id);
    setMycart_data(next);
    api_savecart(next);
  };

  /* New state for delete mode: 'single' (default) or 'bulk' */
  const [delete_mode, setDelete_mode] = useState('single');

  function showDialogCallback_Confirm(message) {
    if (delete_mode === 'bulk') {
      submit_delete_selected();
    } else {
      submit_deletecart(remove_id);
    }
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
  }

  const submit_delete_selected = () => {
    // Filter out items that are selected
    const nexttableitem = mycart_data
      .map((shop) => {
        const nextcartitem = shop.cartitem.filter((item) => item.select_common !== true);
        return {
          ...shop,
          cartitem: nextcartitem,
        };
      })
      .filter((shop) => shop.cartitem.length > 0);

    setMycart_data(nexttableitem);
    api_savecart(nexttableitem);
  };

  const hasSelectedItems = mycart_data.some((shop) =>
    shop.cartitem.some((item) => item.select_common === true),
  );

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const cartQuery = useQuery({
    queryKey: ['cart', shopId],
    queryFn: async () => {
      await sleep(200);
      const formData = new FormData();
      formData.append('buyer_shopid', shopId);
      formData.append('coupon_id', '');
      formData.append('deliver_req', 'disable');
      formData.append('sourcetype', 'cart');

      const response = await client.post('/api/order/mycart/cartlist', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data;',
        },
      });
      if (response.data.status !== 'OK') {
        const err = new Error(response.data.message || 'cartlist failed');
        err.isWarning = true;
        throw err;
      }
      return response.data;
    },
    enabled: !!shopId,
  });

  const editCartMutation = useMutation({
    mutationFn: async ({ cartData, showLoading }) => {
      if (showLoading !== false) {
        await sleep(200);
      }
      const formData = new FormData();
      formData.append('cart_data', JSON.stringify(cartData));
      formData.append('buyer_shopid', shopId);

      const response = await client.post('/api/order/mycart/edit', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data;',
        },
      });
      return response.data;
    },
    onSuccess: (data, variables) => {
      if (data.status !== 'OK') {
        setModal_popup({
          modaltype: 'modal-warning',
          headers: 'ขออภัย',
          message: data.message,
          enable: true,
        });
        return;
      }

      queryClient.invalidateQueries({ queryKey: ['cart', shopId] });
      props.callback_mycart('edit', data.cart_count);

      if (variables.intent === 'checkout') {
        if (data.itemselected > 0) {
          navigate('/marketplace/mypayment?source=cart&shopitem=none&item=none');
        } else {
          setModal_popup({
            modaltype: 'modal-warning',
            headers: 'ขออภัย',
            message: 'ขออภัย กรุณาเลือกสินค้าเพื่อชำระเงิน',
            enable: true,
          });
        }
      } else if (variables.showPopup) {
        setModal_popup({
          modaltype: 'modal-success',
          headers: 'สำเร็จ',
          message: data.message,
          enable: true,
        });
      }
    },
    onError: (err, variables) => {
      if (variables?.showLoading !== false) {
        setmodal_load({ enable: false, message: '' });
      }
      setModal_popup({
        modaltype: 'modal-error',
        headers: 'ผิดพลาด',
        message: err.message,
        enable: true,
      });
    },
  });

  useEffect(() => {
    if (!cartQuery.data) return;
    if (cartQuery.data.cartdata !== undefined) {
      setMycart_data(cartQuery.data.cartdata);
      props.callback_mycart('edit', cartQuery.data.cartdata.length);
    } else {
      setMycart_data([]);
      props.callback_mycart('edit', 0);
    }
  }, [cartQuery.data]);

  useEffect(() => {
    if (shopId) {
      cartQuery.refetch();
    }
  }, [location]);

  useEffect(() => {
    if (cartQuery.isFetching && !cartQuery.data) {
      setmodal_load({ enable: true, message: 'กำลังโหลดตะกร้าสินค้า' });
    } else if (editCartMutation.isPending && editCartMutation.variables?.showLoading !== false) {
      setmodal_load({ enable: true, message: 'กำลังบันทึกตะกร้าสินค้า' });
    } else {
      setmodal_load({ enable: false, message: '' });
    }
  }, [
    cartQuery.isFetching,
    cartQuery.data,
    editCartMutation.isPending,
    editCartMutation.variables,
  ]);

  useEffect(() => {
    if (!cartQuery.isError) return;
    setmodal_load({ enable: false, message: '' });
    setModal_popup({
      modaltype: cartQuery.error?.isWarning ? 'modal-warning' : 'modal-error',
      headers: cartQuery.error?.isWarning ? 'ขออภัย' : 'ผิดพลาด',
      message: cartQuery.error?.message ?? 'ผิดพลาด',
      enable: true,
    });
  }, [cartQuery.isError, cartQuery.error]);

  useEffect(() => {
    var temp = [];
    mycart_data.map((shop) => {
      var sum = 0;
      const nextcartitem = shop.cartitem.map((cartitem) => {
        cartitem.cartitem_pricelist.map((cartitem_pricelist) => {
          sum += cartitem_pricelist.subtotal;
        });
      });
      temp.push({
        shop_id: shop.seller_shopid,
        shop_name: shop.seller_shopname,
        shop_price: sum,
      });
    });
    setMycart_summary(temp);
  }, [mycart_data]);

  function calitemubtotal(normal, porimotion, select) {
    if (Number(porimotion) > 0) {
      return Number(porimotion) * Number(select);
    } else {
      return Number(normal) * Number(select);
    }
  }

  function selectunit(cart_id, cartitem_id, pricelist_id, exp, unit, value) {
    const nexttableitem = mycart_data.map((shop) => {
      if (shop.cart_id !== cart_id) {
        return shop;
      } else {
        const nextcartitem = shop.cartitem.map((cartitem) => {
          if (cartitem.cartitem_id === cartitem_id && cartitem.select_common === true) {
            const nextpriceitem = cartitem.cartitem_pricelist.map((cartitem_pricelist) => {
              if (cartitem_pricelist.pricelist_id === pricelist_id) {
                if (!value || value === '') {
                  return {
                    ...cartitem_pricelist,
                    select: '',
                    subtotal: 0,
                  };
                }

                if (Number(value) > 0) {
                  var fnd = cartitem.on_stock_array.find((element) => {
                    return element.expire === exp;
                  });
                  if (fnd !== undefined) {
                    var new_sum = Number(value) * Number(unit);
                    if (new_sum <= Number(fnd.stock)) {
                      return {
                        ...cartitem_pricelist,
                        select: value,
                        subtotal: calitemubtotal(
                          cartitem_pricelist.price,
                          cartitem_pricelist.pricepromotion,
                          value,
                        ),
                      };
                    } else {
                      return cartitem_pricelist;
                    }
                  } else {
                    return {
                      ...cartitem_pricelist,
                      select: 0,
                      subtotal: 0,
                    };
                  }
                } else {
                  return {
                    ...cartitem_pricelist,
                    select: 0,
                    subtotal: 0,
                  };
                }
              } else {
                return cartitem_pricelist;
              }
            });
            return {
              ...cartitem,
              cartitem_pricelist: nextpriceitem,
            };
          } else {
            return cartitem;
          }
        });
        return {
          ...shop,
          cartitem: nextcartitem,
        };
      }
    });
    setMycart_data(nexttableitem);
    api_savecart(nexttableitem, false, false);
  }

  function stepup(cart_id, cartitem_id, pricelist_id, exp, unit) {
    const nexttableitem = mycart_data.map((shop) => {
      if (shop.cart_id !== cart_id) {
        return shop;
      } else {
        const nextcartitem = shop.cartitem.map((cartitem) => {
          if (cartitem.cartitem_id === cartitem_id && cartitem.select_common === true) {
            const nextpriceitem = cartitem.cartitem_pricelist.map((cartitem_pricelist) => {
              if (cartitem_pricelist.pricelist_id === pricelist_id) {
                var fnd = cartitem.on_stock_array.find((element) => {
                  return element.expire === exp;
                });
                if (fnd !== undefined) {
                  var previous_sum = 0;
                  cartitem.cartitem_pricelist.map((item) => {
                    previous_sum += Number(item.select) * Number(item.unit);
                  });
                  var new_sum = previous_sum + Number(unit);
                  if (new_sum <= Number(fnd.stock)) {
                    return {
                      ...cartitem_pricelist,
                      select: Number(cartitem_pricelist.select) + 1,
                      subtotal: calitemubtotal(
                        cartitem_pricelist.price,
                        cartitem_pricelist.pricepromotion,
                        Number(cartitem_pricelist.select) + 1,
                      ),
                    };
                  } else {
                    return cartitem_pricelist;
                  }
                } else {
                  return {
                    ...cartitem_pricelist,
                    select: 0,
                    subtotal: 0,
                  };
                }
              } else {
                return cartitem_pricelist;
              }
            });
            return {
              ...cartitem,
              cartitem_pricelist: nextpriceitem,
            };
          } else {
            return cartitem;
          }
        });
        return {
          ...shop,
          cartitem: nextcartitem,
        };
      }
    });
    setMycart_data(nexttableitem);
    api_savecart(nexttableitem, false, false);
  }

  function stepdown(cart_id, cartitem_id, pricelist_id) {
    const nexttableitem = mycart_data.map((shop) => {
      if (shop.cart_id !== cart_id) {
        return shop;
      } else {
        const nextcartitem = shop.cartitem.map((cartitem) => {
          if (cartitem.cartitem_id === cartitem_id && cartitem.select_common === true) {
            const nextpriceitem = cartitem.cartitem_pricelist.map((cartitem_pricelist) => {
              if (cartitem_pricelist.pricelist_id === pricelist_id) {
                if (Number(cartitem_pricelist.select) > 0) {
                  return {
                    ...cartitem_pricelist,
                    select: Number(cartitem_pricelist.select) - 1,
                    subtotal: calitemubtotal(
                      cartitem_pricelist.price,
                      cartitem_pricelist.pricepromotion,
                      Number(cartitem_pricelist.select) - 1,
                    ),
                  };
                } else {
                  return cartitem_pricelist;
                }
              } else {
                return cartitem_pricelist;
              }
            });
            return {
              ...cartitem,
              cartitem_pricelist: nextpriceitem,
            };
          } else {
            return cartitem;
          }
        });
        return {
          ...shop,
          cartitem: nextcartitem,
        };
      }
    });
    setMycart_data(nexttableitem);
    api_savecart(nexttableitem, false, false);
  }

  function removepricelist(cart_id, cartitem_id, pricelist_id, cartitem) {
    const nexttableitem = mycart_data.map((shop) => {
      if (shop.cart_id !== cart_id) {
        return shop;
      } else {
        const nextcartitem = shop.cartitem.map((cartitem) => {
          if (cartitem.cartitem_id === cartitem_id && cartitem.select_common === true) {
            const nextpriceitem = cartitem.cartitem_pricelist.filter(function (item) {
              return item.pricelist_id !== pricelist_id;
            });
            return {
              ...cartitem,
              cartitem_pricelist: nextpriceitem,
            };
          } else {
            return cartitem;
          }
        });
        const nextitem = nextcartitem.filter(function (item) {
          return item.cartitem_pricelist.length > 0;
        });
        return {
          ...shop,
          cartitem: nextitem,
        };
      }
    });
    setMycart_data(nexttableitem);
    api_savecart(nexttableitem);
  }

  function unselect_item(value, cart_id, cartitem_id) {
    const nexttableitem = mycart_data.map((shop) => {
      if (shop.cart_id !== cart_id) {
        return shop;
      } else {
        const nextcartitem = shop.cartitem.map((cartitem) => {
          if (cartitem.cartitem_id === cartitem_id) {
            return {
              ...cartitem,
              select_common: value,
            };
          } else {
            return cartitem;
          }
        });
        return {
          ...shop,
          cartitem: nextcartitem,
        };
      }
    });
    setMycart_data(nexttableitem);
    ckeckbox_clearquantity(nexttableitem, value, cart_id, cartitem_id);
    const allSelected =
      nexttableitem.length > 0 &&
      nexttableitem.every((shop) => shop.cartitem.every((item) => item.select_common === true));
    setSelect_all(allSelected);
  }

  function toggleSelectShop(cart_id, value) {
    const nexttableitem = mycart_data.map((shop) => {
      if (shop.cart_id !== cart_id) return shop;
      const nextcartitem = shop.cartitem.map((cartitem) => {
        const nextpriceitem = cartitem.cartitem_pricelist.map((cartitem_pricelist) => {
          if (!value) {
            return {
              ...cartitem_pricelist,
              select: 0,
              subtotal: 0,
            };
          }
          return cartitem_pricelist;
        });
        return {
          ...cartitem,
          select_common: value,
          cartitem_pricelist: nextpriceitem,
        };
      });
      return {
        ...shop,
        cartitem: nextcartitem,
      };
    });
    setMycart_data(nexttableitem);
    const allSelected =
      nexttableitem.length > 0 &&
      nexttableitem.every((shop) => shop.cartitem.every((item) => item.select_common === true));
    setSelect_all(allSelected);
    api_savecart(nexttableitem, false, false);
  }

  useEffect(() => {
    const allSelected =
      mycart_data.length > 0 &&
      mycart_data.every((shop) => shop.cartitem.every((item) => item.select_common === true));
    setSelect_all(allSelected);
  }, [mycart_data]);

  function toggleSelectAll(value) {
    setSelect_all(value);
    const nexttableitem = mycart_data.map((shop) => {
      const nextcartitem = shop.cartitem.map((cartitem) => {
        const nextpriceitem = cartitem.cartitem_pricelist.map((cartitem_pricelist) => {
          if (value) {
            return cartitem_pricelist;
          } else {
            return {
              ...cartitem_pricelist,
              select: 0,
              subtotal: 0,
            };
          }
        });
        return {
          ...cartitem,
          select_common: value,
          cartitem_pricelist: nextpriceitem,
        };
      });
      return {
        ...shop,
        cartitem: nextcartitem,
      };
    });
    setMycart_data(nexttableitem);
    api_savecart(nexttableitem, false, false);
  }

  function ckeckbox_clearquantity(data, value, cart_id, cartitem_id) {
    if (value === false) {
      const nexttableitem = data.map((shop) => {
        if (shop.cart_id !== cart_id) {
          return shop;
        } else {
          const nextcartitem = shop.cartitem.map((cartitem) => {
            if (cartitem.cartitem_id === cartitem_id) {
              const nextpriceitem = cartitem.cartitem_pricelist.map((cartitem_pricelist) => {
                return {
                  ...cartitem_pricelist,
                  select: 0,
                  subtotal: 0,
                };
              });
              return {
                ...cartitem,
                cartitem_pricelist: nextpriceitem,
              };
            } else {
              return cartitem;
            }
          });
          return {
            ...shop,
            cartitem: nextcartitem,
          };
        }
      });
      setMycart_data(nexttableitem);
    }
  }

  function api_savecartpay() {
    if (mycart_data.length > 0) {
      editCartMutation.mutate({
        cartData: mycart_data,
        showPopup: false,
        showLoading: true,
        intent: 'checkout',
      });
    } else {
      setModal_popup({
        modaltype: 'modal-warning',
        headers: 'ขออภัย',
        message: 'ไม่มีรายการสินค้าในตะกร้าให้สั่งซื้อ',
        enable: true,
      });
    }
  }

  function api_savecart(cartData, showPopup = true, showLoading = true) {
    const dataToSave = cartData !== undefined ? cartData : mycart_data;
    if (dataToSave.length > 0 || (dataToSave.length === 0 && props.mycartlen > 0)) {
      editCartMutation.mutate({
        cartData: dataToSave,
        showPopup,
        showLoading,
        intent: 'save',
      });
    } else {
      setModal_popup({
        modaltype: 'modal-warning',
        headers: 'ขออภัย',
        message: 'ไม่มีรายการสินค้าในตะกร้าให้บันทึก',
        enable: true,
      });
    }
  }

  function getinpuralertstock(selectvalue, expire, stockarray) {
    var res = stockarray.filter(function (item) {
      return item.expire === expire;
    });
    if (res.length > 0) {
      if (selectvalue > res[0].stock) {
        return ' inputnumeric-alert';
      } else {
        return ' border border-color-1';
      }
    } else {
      return ' border border-color-1';
    }
  }

  return (
    <main id='content' role='main' className='bg-gray-13'>
      <div className='container py-4'>
        <nav aria-label='breadcrumb' className='d-none d-md-block mb-3'>
          <ol className='breadcrumb mb-0 py-0 bg-transparent'>
            <li className='breadcrumb-item font-th'>
              <Link to='/marketplace?category=รวมสินค้า' className='text-primary'>หน้าแรก</Link>
            </li>
            <li className='breadcrumb-item font-th active'>ตะกร้าสินค้าของฉัน</li>
          </ol>
        </nav>

        <div className='row'>
          <div className='col-lg-8 col-xl-9'>
            <div className='mycart-list-header'>
              <label className='master-checkbox m-0'>
                <input
                  type='checkbox'
                  className='d-none'
                  checked={select_all}
                  onChange={(e) => toggleSelectAll(e.target.checked)}
                />
                <span className='checkmark'></span>
                <span className='ml-1 font-th'>เลือกทั้งหมด</span>
              </label>
              <button
                className='btn btn-link text-danger p-0 font-th font-size-14'
                disabled={!hasSelectedItems}
                onClick={() => {
                  setDelete_mode('bulk');
                  setModal_popup({
                    modaltype: 'modal-confirm',
                    headers: 'ยืนยันการลบ',
                    message: 'ต้องการลบสินค้าที่เลือกทั้งหมด ใช่หรือไม่?',
                    enable: true,
                  });
                }}
              >
                <i className='fas fa-trash-alt mr-1'></i> ลบที่เลือก
              </button>
            </div>

            {mycart_data.length > 0 ? (
              mycart_data.map((seller) => (
                <div className='card-mycart' key={seller.seller_shopid}>
                  <div className='card-mycart-header'>
                    <label className='master-checkbox m-0 mr-3'>
                      <input
                        type='checkbox'
                        className='d-none'
                        checked={
                          seller.cartitem.length > 0 &&
                          seller.cartitem.every((it) => it.select_common === true)
                        }
                        onChange={(e) => toggleSelectShop(seller.cart_id, e.target.checked)}
                      />
                      <span className='checkmark'></span>
                    </label>
                    <div className='d-flex flex-column'>
                      <Link
                        to={`/marketplace/shopseller?shopcode=${seller.shop_id || seller.seller_shopid}&category=รวมสินค้า`}
                        className='card-mycart-title'
                      >
                        <i className='fas fa-store'></i> {seller.seller_shopname}
                      </Link>
                      <span className='card-mycart-subtitle'>จังหวัด {seller.seller_shopprovince}</span>
                    </div>
                  </div>

                  <div className='card-mycart-body'>
                    {seller.cartitem.map((cartitems) => (
                      <div className='mycart-item-row' key={cartitems.cartitem_id}>
                        <div className='mycart-box-check'>
                          <label className='master-checkbox m-0'>
                            <input
                              type='checkbox'
                              className='d-none'
                              checked={cartitems.select_common}
                              onChange={(e) => unselect_item(e.target.checked, cartitems.cart_id, cartitems.cartitem_id)}
                            />
                            <span className='checkmark'></span>
                          </label>
                        </div>
                        <div className='mycart-box-image'>
                          <img
                            src={
                              cartitems.productitem_id && cartitems.img1_key
                                ? `${process.env.REACT_APP_IMAGE_URL}${cartitems.productitem_id}/${cartitems.productitem_id}-1-${cartitems.img1_key}.jpg`
                                : placeholderImg
                            }
                            alt={cartitems.productitem_name}
                          />
                        </div>
                        <div className='mycart-item-info'>
                          <div className='mycart-box-productname'>{cartitems.productitem_name}</div>
                          <div className='mycart-box-productinter'>{cartitems.productitem_inter}</div>

                          <div className='mycart-pricelist-container'>
                            {cartitems.cartitem_pricelist.map((pricelist) => (
                              <div className='pricelist-item' key={pricelist.pricelist_id}>
                                <div className='pricelist-top'>
                                  <div className='pricelist-unit-info'>
                                    {pricelist.unit} ชิ้น / <strong>฿{calitemubtotal(pricelist.price, pricelist.pricepromotion, 1)}</strong>
                                  </div>
                                  <div className='pricelist-expiry'>
                                    Exp. {dayjs(new Date(pricelist.expire)).format('DD MMM BBBB')}
                                  </div>
                                </div>
                                <div className='pricelist-actions'>
                                  <div className={`quantity-control ${getinpuralertstock(pricelist.select, pricelist.expire, cartitems.on_stock_array).includes('alert') ? 'border-danger' : ''}`}>
                                    <div className='qty-btn' onClick={() => stepdown(pricelist.cart_id, pricelist.cartitem_id, pricelist.pricelist_id)}>
                                      <i className='fas fa-minus'></i>
                                    </div>
                                    <input
                                      type='text'
                                      className='qty-input'
                                      value={pricelist.select}
                                      onChange={(e) => selectunit(pricelist.cart_id, pricelist.cartitem_id, pricelist.pricelist_id, pricelist.expire, pricelist.unit, e.target.value)}
                                    />
                                    <div className='qty-btn' onClick={() => stepup(pricelist.cart_id, pricelist.cartitem_id, pricelist.pricelist_id, pricelist.expire, pricelist.unit)}>
                                      <i className='fas fa-plus'></i>
                                    </div>
                                  </div>
                                  <div className='d-flex align-items-center'>
                                    <div className='pricelist-subtotal'>฿{pricelist.subtotal.toLocaleString()}</div>
                                    <div className='item-remove-btn' onClick={() => removepricelist(pricelist.cart_id, pricelist.cartitem_id, pricelist.pricelist_id, cartitems)}>
                                      <i className='fas fa-trash-alt'></i>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))
            ) : (
              <div className='card-mycart p-5 text-center'>
                <i className='fas fa-shopping-cart fa-3x text-light mb-3'></i>
                <h5 className='font-th'>ไม่มีรายการสินค้าในตะกร้า</h5>
                <Link to='/marketplace?category=รวมสินค้า' className='btn btn-primary mt-3 font-th'>ไปช้อปปิ้งเลย</Link>
              </div>
            )}
          </div>

          <div className='col-lg-4 col-xl-3 mt-4 mt-lg-0'>
            <div className='mycart-summary'>
              <div className='summary-title font-th'>จำนวนเงินรวม</div>
              {mycart_summary.map((seller, index) => (
                <div className='summary-row font-th' key={seller.shop_id}>
                  <span>{index + 1}. {seller.shop_name}</span>
                  <strong>฿ {Number(seller.shop_price).toLocaleString(undefined, { minimumFractionDigits: 2 })}</strong>
                </div>
              ))}
              <div className='summary-row summary-total font-th'>
                <span>รวมทั้งหมด</span>
                <strong>
                  ฿ {Number(mycart_summary.reduce((total, cur) => total + Number(cur.shop_price), 0)).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                </strong>
              </div>
              <div className='summary-subtitle text-center font-th text-muted mb-3' style={{ fontSize: '11px' }}>
                ยังไม่รวมค่าขนส่ง (คำนวณในขั้นตอนถัดไป)
              </div>
              <button className='checkout-btn font-th' onClick={() => api_savecartpay()}>
                ดำเนินการสั่งซื้อ
              </button>
            </div>
          </div>
        </div>
      </div>

      <ModalLoad option={modal_load}></ModalLoad>
      <ModalPopupMessage
        callback_general={showDialogCallback_General}
        callback_confirm={showDialogCallback_Confirm}
        options={modal_popup}
      />
    </main>
  );
}

export default MyCart;
